import { updateEmployee } from "directus/src/operations";
import { getUserFields } from "components/user/config";
import { useMutation } from "@tanstack/react-query";
import { invalidateAllQueries } from "utils/utils";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

function buildPayload(values, userId) {
  if (!values || typeof values !== "object") return {};

  const { reports_to, role, status, ...rest } = values;

  return {
    ...rest,
    ...((role || status) && {
      user: {
        id: userId,
        ...(role && { role }),
        ...(status && { status }),
      },
    }),
    reports_to: reports_to?.id,
  };
}

export function useUpdateUser() {
    const navigate = useNavigate();
  return useMutation({
    mutationFn: async ({ id, values, userId }) => {
      const payload = buildPayload(values, userId);
      const query = {
        fields: [
          ...getUserFields(),
          getUserFields("reports_to"),
          "department.id",
          "user.role.id",
          "*",
        ],
      };

      try {
        const response = await updateEmployee(id, payload, query);
        return response;
      } catch (error) {
        throw error;
      }
    },
    onSuccess: () => {
      toast.success("User Updated Successfully");
      invalidateAllQueries();
      navigate(-1);
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
